import styled from 'styled-components';
import CopyToClipboardButton from 'components/CopyToClipboardButton';

export const CellWrapper = styled.div`
    display: flex;
    height: 100%;
    padding: 0.5rem 1rem;
    align-items: center;
    gap: 1rem;
    flex: 1 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ActionsCellWrapper = styled(CellWrapper)`
    justify-content: flex-start;
    padding: 0 2rem 0 0;
    gap: 1.75rem;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
    margin-right: 1.5rem;
`;

export const StyledCopyToClipboardButton = styled(CopyToClipboardButton)`
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
`;

export const StyledA = styled.a`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CapitalizedText = styled.span`
    text-transform: capitalize;
`;
